import { render } from "./mobile-size-selector.vue?vue&type=template&id=8a220b9e"
import script from "./mobile-size-selector.vue?vue&type=script&lang=js"
export * from "./mobile-size-selector.vue?vue&type=script&lang=js"

import "./mobile-size-selector.vue?vue&type=style&index=0&id=8a220b9e&lang=scss"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__